import ParcelexApi from '@/services/parcelex';
import globals from '@/globals';
import logger from '../../lib/logger';
import { partners } from '../../utils/partners';
// import retargetingMock from './retargeting.mock';

function calculate({ value, interest, installments }) {
  const pv = value;
  // eslint-disable-next-line max-len
  const pmt = pv * ((((1 + interest) ** installments) * interest) / (((1 + interest) ** installments) - 1));
  return {
    numberOfInstallments: installments,
    installmentValue: parseFloat((pmt).toFixed(2)),
    interest,
    totalValue: parseFloat((installments * pmt).toFixed(2)),
  };
}

const categoryTemplate = {
  smartphone: {
    name: 'Celular e Smartphone',
    title: 'Smartphone',
    logo: 'retargeting/smartphone-category.svg',
    header: {
      title: `Parcele seu novo Smartphone em até ${globals().maxInstallments} vezes no boleto`,
      image: 'smartphone',
      imageStyle: 'position: absolute; top: 126px; right: 74px; width: 566px; height: 474px',
      mobileImageStyle: 'position: absolute; bottom: -1px; max-height: 45vh; max-width: 96vw; right: 50%; transform: translate(50%);',
    },
  },
  lavadora: {
    name: 'Lavadora de Roupas',
    title: 'Máquina de lavar',
    logo: 'retargeting/washing-machine.svg',
    header: {
      title: `Parcele sua nova Máquina de Lavar no boleto em até ${globals().maxInstallments} vezes`,
      image: 'washing-machine',
      imageStyle: 'position: absolute; bottom: -57px; right: 88px; height: 581px; width: 581px;',
      mobileImageStyle: 'position: absolute; bottom: 0; max-height: 56.2vh; max-width: 100vw; right: 50%; transform: translate(50%);',
    },
  },
  tv: {
    name: 'TV',
    title: 'Smart TV',
    logo: 'retargeting/tv-category.svg',
    header: {
      title: `Parcele sua nova Smart TV no boleto em até ${globals().maxInstallments} vezes`,
      image: 'smart-tv',
      imageStyle: 'position: absolute; bottom: 0; right: 36px; width: 614px; height: 434px',
      mobileImageStyle: 'position: absolute; bottom: 7.8vh; width: 100vw; right: 50%; transform: translate(50%);',
    },
  },
  geladeira: {
    name: 'Geladeira',
    title: 'Geladeira',
    logo: 'retargeting/refrigerator-category.svg',
    header: {
      title: `Parcele sua nova Geladeira no boleto em até ${globals().maxInstallments} vezes`,
      image: 'fridge',
      imageStyle: 'position: absolute; top: 0; right: -21px; width: 710px; height: 710px',
      mobileImageStyle: 'position: absolute; left: -3.2vw; bottom: -4.6vh; width: 114.67vw; height: 64.46vh;',
    },
  },
  fogao: {
    name: 'Fogão',
    title: 'Fogão',
    logo: 'retargeting/stove-category.svg',
    header: {
      title: `Parcele seu novo Fogão no boleto em até ${globals().maxInstallments} vezes`,
      image: 'stove',
      imageStyle: 'position: absolute; top: 51px; right: 34px; width: 690px; height: 690px',
      mobileImageStyle: 'position: absolute; right: -7.2vw; bottom: -5.3vh; max-height: 67.91vh; max-width: 120.8vw;',
    },
  },
  arcondicionado: {
    name: 'Ar-Condicionado',
    title: 'Ar Condicionado',
    logo: 'retargeting/air-conditioner-category.svg',
    header: {
      title: `Parcele seu novo Ar-condicionado no boleto em até ${globals().maxInstallments} vezes`,
      image: 'air-conditioning',
      imageStyle: 'position: absolute; bottom: 0; right: 128px; width: 522px; height: 522px;',
      mobileImageStyle: 'position: absolute; right: 2.67vw; bottom: 6.9vh; max-height: 61.3vh; max-width: 109vw;',
    },
  },
  notebook: {
    name: 'Notebook',
    title: 'Notebook',
    logo: 'retargeting/notebook-category.svg',
    header: {
      title: `Parcele seu novo Notebook no boleto em até ${globals().maxInstallments} vezes`,
      image: 'notebook',
      imageStyle: 'position: absolute; bottom: 0; right: 47px; width: 631px; height: 631px;',
      mobileImageStyle: 'position: absolute; bottom: 7.5vh; max-height: 56.2vh; max-width: 100vw; right: 50%; transform: translate(50%);',
    },
  },
  tablet: {
    name: 'Tablet',
    title: 'Tablet',
    logo: 'retargeting/tablet-category.svg',
    header: {
      title: `Parcele seu novo Tablet no boleto em até ${globals().maxInstallments} vezes`,
      image: 'tablet',
      imageStyle: 'position: absolute; bottom: -93px; right: 119px; width: 467px; height: 577px;',
      mobileImageStyle: 'position: absolute; bottom: 5.8vh; max-height: 43.8vh; max-width: 69.6vw; right: 50%; transform: translate(50%);',
    },
  },
};

export default {
  namespaced: true,
  state: {
    mainOffer: undefined,
    offers: new Array(5).fill({ loading: true }),
    categories: Object.keys(categoryTemplate).map((key) => ({
      slug: key,
      ...categoryTemplate[key],
    })),
    category: null,
    header: {},
    teste: null,
  },
  actions: {
    async setCategory({ commit }, category = 'smartphone') {
      const template = categoryTemplate[category];
      commit('setCategoryData', {
        category,
        template: categoryTemplate[category],
      });

      if (!template.offers) {
        try {
          const { data } = await ParcelexApi(`/retargeting/offers/${template.name}`);
          template.offers = data.map((el) => ({
            ...el,
            ...calculate({
              value: el.price,
              interest: 0.05,
              installments: globals().maxInstallments,
            }),
          }))
            .map((offer) => {
              const partner = partners.find((part) => part.title === offer.retailerName);
              const storeUrl = partner?.link || undefined;
              const newOffer = { ...offer, storeUrl };
              return newOffer;
            });
        } catch (error) {
          logger.error(error);
        }
      }
      commit('setOffers', template.offers);
    },
    async setMainOffer({ rootState, commit }) {
      const checkoutId = rootState && rootState.checkout && rootState.checkout.checkoutId;
      if (checkoutId) {
        try {
          const { data } = await ParcelexApi(`/retargeting/checkout/${checkoutId}`);
          const { retailerName } = data;
          const partner = partners.find((part) => part.title === retailerName);
          const storeUrl = partner?.link || undefined;

          if (rootState.checkout.options.result === 'DENIED') {
            commit('setMainOffer', {
              mainOffer: {
                ...data,
                ...calculate({
                  value: data.price,
                  interest: rootState.checkout.simulation.interest || 0.05,
                  installments: rootState.checkout.simulation.installmentsNumber
                    || globals().maxInstallments,
                }),
                storeUrl,
              },
            });
          } else {
            commit('setMainOffer', {
              mainOffer: {
                ...data,
                installmentValue: data.paymentInstallments,
                interest: data.interestRatePM,
                totalValue: data.totalAmount,
                storeUrl,
              },
            });
          }
        } catch (error) {
          if ((error.response && error.response.status !== 404)
            || (error.response && error.response.data !== 'checkout not found')) {
            logger.error(error);
          }
        }
      }
    },
  },
  mutations: {
    setMainOffer(state, { mainOffer } = {}) {
      state.mainOffer = mainOffer;
    },
    setOffers(state, offers) {
      state.offers = offers;
    },
    setCategoryData(state, { category, template }) {
      state.category = category;
      state.header = template.header;
    },
  },
  getters: {
    getOffers(state) {
      return state.mainOffer ? state.offers : state.offers.slice(1);
    },
    getMainOffer(state) {
      return state.mainOffer ? state.mainOffer : state.offers[0];
    },
  },
};
